var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipMealBowl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.21 1.5 1.5 6.2 1.5 12C1.5 17.8 6.21 22.5 12 22.5C17.79 22.5 22.5 17.8 22.5 12C22.5 6.2 17.8 1.5 12 1.5ZM6.21 5L8.55 7.34C9.25 6.79 10.12 6.5 11 6.5C11.63 6.5 12.25 6.65 12.8 6.93C13.36 7.21 13.85 7.62 14.22 8.13C14.47 8.04 14.74 8 15 8C15.67 8 16.3 8.26 16.77 8.73C17.24 9.2 17.5 9.83 17.5 10.5H16.5C16.5 10.19 16.41 9.88 16.23 9.63C16.05 9.38 15.79 9.19 15.5 9.08C15.21 8.98 14.89 8.97 14.59 9.06C14.29 9.14 14.03 9.32 13.83 9.56C13.6 9.85 13.3 10.09 12.96 10.25C12.63 10.41 12.26 10.5 11.88 10.5H10V9.5H11.88C12.11 9.5 12.33 9.45 12.53 9.35C12.73 9.25 12.91 9.11 13.05 8.93C13.14 8.83 13.24 8.72 13.35 8.63C13.07 8.28 12.71 7.99 12.31 7.8C11.9 7.6 11.46 7.5 11 7.5C10.61 7.5 10.22 7.57 9.86 7.72C9.49 7.88 9.16 8.1 8.88 8.38L8.53 8.73L5.5 5.7L6.21 5ZM19.01 12C19.01 13.86 18.27 15.64 16.96 16.95C15.64 18.26 13.86 19 12.01 19C10.16 19 8.37 18.26 7.06 16.95C5.74 15.64 5.01 13.86 5.01 12V11.5H8.3L5.01 8.21L5.71 7.5L9.71 11.5H19.01V12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipMealBowl);
export default __webpack_public_path__ + "static/media/ic-chip-meal-bowl.de74c9bc304c3af21aec61474ececfaf.svg";
export { ForwardRef as ReactComponent };